import React, { memo } from 'react'
import { Button as MuiButton } from '@mui/material'

const Button = ({ label, ...restProps }) => {
  return (
    <MuiButton
      variant='contained'
      size='default'
      loadingPosition='end'
      {...restProps}
    >
      {label}
    </MuiButton>
  )
}

export default memo(Button)
